<template>
  <div :key="skeletonKey" class="filtering-facets-skeleton margin-top-l">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9 large-10">
        <AtomicUiSkeleton width="88px" height="50px" />
      </div>
      <div class="cell small-3 medium-3 large-2 hide-for-small-only">
        <AtomicUiSkeleton width="100%" height="50px" />
      </div>
    </div>
  </div>
</template>

<script setup>
const skeletonKey = ref(1);

onMounted(() => {
  skeletonKey.value += 1;
});
</script>
